<template>
    <div class="nav">
        <div>
            <div class="go-back" @click="clickLeft" v-if="leftShow"></div>
        </div>
        <p class="title">{{title}}</p>
        <slot>
            <div class="right"></div>
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        leftShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        clickLeft() {
            this.$emit('leftClick')
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/components/content/home/css/common.less';
</style>



// WEBPACK FOOTER //
// src/components/common/Nav.vue